import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { SunMark } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = (location.hash || "").replace("#session_id=", "").trim();
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => {
        window.history.replaceState({}, "", "/admin");
        navigate("/admin", { state: { user: res.data?.user }, replace: true });
      })
      .catch(() => {
        window.history.replaceState({}, "", "/admin");
        navigate("/admin", { replace: true });
      });
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen bg-cream flex flex-col items-center justify-center gap-4">
      <SunMark className="w-12 h-9 text-sun animate-pulse" />
      <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-deep">Signing you in…</p>
    </div>
  );
};

export default AuthCallback;
